<template>
  <div :style="{ position: 'relative' }">
    <Loading
      :active.sync="loading"
      :isFullPage="false"
      :zIndex="9000"
    ></Loading>
    <Toast :style="{ width: $isMobile() ? '100vw' : '' }" />
    <Dialog
      id="dialog-add-part"
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '50vw' }"
      v-bind:class="[{ 'p-dialog-maximized': $isMobile() }]"
      :modal="true"
      :closable="false"
      :header="'Aplicar Peça'"
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-col-12">
          <div class="p-col-12 p-mb-3">
            <span class="p-input-icon-left search-wrapper">
              <i class="pi pi-search" />
              <InputText
                v-model="search"
                placeholder="Pesquisar por referência ou designação..."
                @input="searchProduct"
                class="search-input"
              />
            </span>
            <small>Selecione uma peça</small>
          </div>
        </div>

          <div
            class="p-col-12 p-md-6 product-card-wrapper p-mb-2"
            v-for="(inStock, index) in stockFilter"
            :key="index"
          >
            <div
              :class="[
                'product-card',
                { 'selected': parts.includes(inStock.idx) },
                { 'disabled': inStock.isAlreadyPresent }
              ]"
              @click="selectPart(inStock.idx)"
            >
            <div class="card-content">
              <!-- Selection Indicator -->
              <div class="selection-indicator" v-if="parts.includes(inStock.idx)">
                <i class="pi pi-check-circle"></i>
              </div>

              <!-- Product Info -->
              <div class="product-info">
                <div class="info-row">
                  <span class="label">Referência:</span>
                  <span class="value">{{ inStock.ref }}</span>
                </div>
                <div class="info-row">
                  <span class="label">Designação:</span>
                  <span class="value">{{ inStock.design }}</span>
                </div>
                <div class="info-row">
                  <span class="label">Armazém:</span>
                  <span class="value">{{ inStock.destination_warehouse_name }}</span>
                </div>
                <div class="info-row-quantity">
                  <div class="info-row quantity-row">
                    <span class="label">Quantidade:</span>
                    <span class="quantity-badge">
                      1 unidade
                    </span>
                  </div>
                  <div v-if="inStock.isAlreadyPresent" class="info-row quantity-row">
                    <span class="label">Adicionado:</span>
                    <span class="quantity-added-badge">
                      1 unidade
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="stockFilter.length === 0 && !takePhoto" class="p-col-12 no-results">
            <i class="pi pi-inbox"></i>
            <p>Nenhuma peça encontrada</p>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          :label="'Adicionar'"
          icon="pi pi-save"
          class="p-button-success"
          :disabled="parts.length === 0"
          @click="applyPart"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="close"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import supportService from "../../services/support.service";
import patService from "../../services/pat.service";
import stockService from "../../services/stock.service";

export default {
  name: "AddPart",
  props: ["show", "service"],
  components: { Loading },
  watch: {
    async show() {
      if (this.show === true) {
        this.task_id = this.service.id;
        await this.getCurrentWorkSheet();
        await this.getWarehouses();
        this.stock = await patService.getPatParts(this.service.pat_number);
        this.stock.forEach(e => e.ref = e.ref.trim())
        const alreadyAdded = this.currentWorkSheetLines;

        this.stockFilter = this.stock.reduce((acc, product) => {
          if (product.quantity > 0) {
            const addedQty = alreadyAdded[product.ref] || 0;
            for (let i = 0; i < product.quantity; i++) {
              acc.push({
                ...product,
                idx: Math.random().toString(36).slice(2),
                isAlreadyPresent: i < addedQty
              });
            }
          }
          return acc;
        }, []);
      } else {
        this.reset();
      }
    },
  },
  data() {
    return {
      loading: false,
      task_id: null,
      part: null,
      parts: [],
      takePhoto: false,
      hasPhoto: false,
      search: "",
      stock: [],
      stockFilter: [],
      warehouseId: null,
      warehouses: [],
      currentWorkSheet: null,
    };
  },
  computed: {
    currentWorkSheetLines() {
      if (!this.currentWorkSheet || !this.currentWorkSheet.lines) return {};
      return this.currentWorkSheet.lines.reduce((acc, line) => {
        const ref = line.reference ? line.reference.trim() : '';
        acc[ref] = (line.quantity || 0);
        return acc;
      }, {});
    }
  },
  methods: {
    async getCurrentWorkSheet() {
      try {
        const response = await patService.getWorkSheet(this.service.pat_number);
        this.currentWorkSheet = response;
      } catch (error) {
        console.error("Erro ao obter a folha de trabalho:", error);
      }
    },
    async getWarehouses() {
      try {
        const response = await stockService.getStorages();
        this.warehouses = response.data;
      } catch (error) {
        console.error("Erro ao obter os armazéns:", error);
      }
    },
    selectPart(idx) {
      let stock = this.stockFilter.find((e) => e.idx === idx);

      if (!stock) {
        return this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Selecione um armazém válido para esta peça",
          life: 5000,
        });
      }

      this.part = stock.ref;
      if (this.parts.includes(stock.idx)) {
        this.parts.splice(this.parts.indexOf(stock.idx), 1);
        return;
      }

      this.parts.push(stock.idx);

      this.warehouseId = stock.destination_warehouse_id;
    },
    reset() {
      this.task_id = null;
      this.part = null;
      this.parts = [];
      this.hasPhoto = false;
      this.takePhoto = false;
      this.stock = [];
      this.stockFilter = [];
      this.search = "";
      return (this.loading = false);
    },
    close() {
      this.reset();
      this.$validator.pause();
      return this.$emit("close");
    },

    async applyPart() {

      if (this.parts.length === 0) {
        return this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail: "Selecione pelo menos uma peça para adicionar",
          life: 5000,
        });
      }

      let formData = [];

      for (let idx of this.parts) {
        let stock = this.stockFilter.find((e) => e.idx === idx);
        if (!stock) {
          return this.$toast.add({
            severity: "error",
            summary: "Erro",
            detail: "Selecione um armazém válido para esta peça",
            life: 5000,
          });
        }

        formData.push(stock);
      }

      return supportService
        .addPartToIntervention(this.task_id, {parts: formData})
        .then((response) => {
          this.loading = false;

          if (response.status >= 400) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: response.data.message || "Erro ao adicionar a peça",
              life: 5000,
            });
          }

          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Erro ao adicionar a peça",
              life: 5000,
            });
          }

          this.$toast.add({
            severity: "success",
            summary: "Sucesso",
            detail: "Peça adicionada com sucesso",
            life: 5000,
          });

          this.reset();
          return this.$emit("addedPart");
        });
    },
    searchProduct() {
      const search = this.search.toLowerCase();
      this.stockFilter = this.stock.filter((product) => {
        return (
          product.ref.toLowerCase().includes(search) ||
          product.design.toLowerCase().includes(search)
        );
      });
    },
    addPart() {
      this.takePhoto = true;
      return (this.stockFilter = this.stock.filter((product) => {
        return product.ref === this.part;
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.p-dialog-content {
  min-width: 50vh !important;
}

.search-wrapper {
  width: 100%;

  .search-input {
    width: 100%;
    padding-left: 2.5rem;
    font-size: 1rem;
  }
}

.product-card-wrapper {
  padding: 0.5rem;
}

.product-card {
  position: relative;
  background: #ffffff;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 0;
  height: 100%;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover:not(.disabled) {
    border-color: #007bff;
    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
    transform: translateY(-2px);
  }

  &.selected {
    border-color: #28a745;
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    box-shadow: 0 4px 16px rgba(40, 167, 69, 0.2);

    .selection-indicator {
      display: flex;
    }
  }

  &.disabled {
    opacity: 0.6;
    cursor: not-allowed;
    pointer-events: none;

    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
}

.card-content {
  padding: 1.5rem;
  position: relative;
}

.selection-indicator {
  display: none;
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: #28a745;
  font-size: 1.5rem;
  animation: checkIn 0.3s ease;
}

.info-row-quantity {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
}

@keyframes checkIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.product-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.info-row {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;

  &.quantity-row {
    margin-top: 0.5rem;
  }
}

.label {
  font-size: 0.875rem;
  color: #666;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.value {
  font-size: 1rem;
  color: #333;
  font-weight: 500;
}

.quantity-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: #007bff;
  color: white;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  width: fit-content;
}

.quantity-added-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: #ff9d00;
  color: white;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  width: fit-content;
}

.no-results {
  text-align: center;
  padding: 3rem 1rem;
  color: #999;

  i {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: #ccc;
  }

  p {
    font-size: 1.125rem;
    margin: 0;
  }
}

.upload-section {
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 12px;
  padding: 1.5rem;

  h4 {
    margin: 0 0 1rem 0;
    color: #333;
    font-size: 1.125rem;
  }
}

@media (max-width: 768px) {
  .product-card-wrapper {
    padding: 0.375rem;
    margin-bottom: 1rem;
  }

  .product-card {
    margin-bottom: 0;
  }

  .card-content {
    padding: 1rem;
  }

  .selection-indicator {
    font-size: 1.25rem;
    top: 0.75rem;
    right: 0.75rem;
  }
}
</style>